import {fetch} from '@/utils/fetch';

/**
 *
 * @param currentPage
 * @param pageSize
 * @returns {Promise}
 */
export function getWarningList(
  {
    direction, sort,startAt,endAt,warehouseNo,city
  },
) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/warning-orders-report`,
    method: 'get',
    params: {
      direction,
      sort,
      startAt,
      endAt,
      warehouseNo,
      city
    },
  });
}
/**
 *
 * @param currentPage
 * @param pageSize
 * @returns {Promise}
 */
export function cancelWarning() {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/cancel-warning-report`,
    method: 'get',
  });
}
